import { axiosDelete } from '@/api/AxiosApi';
import { sendRequest, EndpointPayload } from '@/api/AxiosRequest';

const BALANCE_API_URL = process.env.REACT_APP_BALANCE_API_URL;

// 코인타입 삭제
export const deleteCoinType = async (coinTypeId: string) => {
  const payload: EndpointPayload = {
    path: `/assetfi/admin/staking/coin-types/${coinTypeId}`,
    apiUrl: BALANCE_API_URL,
  };

  return await sendRequest(payload, 'deleteCoinType', axiosDelete);
};
